(function ($) {

	$(function () {

		if (document.getElementById("name")) {
			document.getElementById("name").addEventListener("click", () => {
				console.log('Focus');
				document.getElementById("name").focus();
			});
		}

		$('#send').on('click', function () {

			var form_length = document.contact.elements.length;
			var test_value = form_length - 2;

			for (loop = 0; loop < test_value; loop++) {

				var name_one = document.contact.elements[loop].name;
				var value_one = document.contact.elements[loop].value;
				if (document.contact.elements[loop].value == '') {
					check_values(name_one);
					return false;
				}

				var mail_checker = /.+@.+\..+/;
				if (name_one.indexOf("email") != -1) {
					if (mail_checker.test(value_one) != true) {
						check_values(name_one);
						return false;
					}
				}
				if (name_one.indexOf("recaptcha") != -1) {
					if (value_one != 7) {
						check_values(name_one);
						return false;
					}
				}
			}

			var name = document.contact.name.value;
			var email = document.contact.email.value;
			var message = document.contact.message.value;

			$('#send').after('<div id="spinner"></div>');

			SaveComments(name, email, message);
			return false;

		});


		function check_values(name_one) {
			if ('recaptcha' == $.trim(name_one)) {
				document.getElementById("validation").innerText = 'Please enter the correct amount';
			} else {
				document.getElementById("validation").innerText = 'Enter ' + name_one;
			}
		}

		function SaveComments(name, email, message) {
			var ajaxurl = CONTACT.ajax_url;
			var data = { 'action': 'my_postal_action', 'name': name, 'email': email, 'message': message, 'nonce': CONTACT.nonce };
			$.ajax({
				url: ajaxurl,
				type: "POST",
				data: data,
				dataType: "json",
				success: function (request) {
					if (request.success == true) {
						setTimeout(function () {
							add_message();
							document.contact.reset();
							$('#spinner').remove();
						}, 1000);
					}
					else {
						$('#spinner').remove();
						const message = request.message ? request.message : CONTACT.error;
						window.document.getElementById("validation").innerText = message;
					}
				},
				error: function (XMLHttpRequest, textStatus, errorThrown) {
					alert("Status: " + textStatus);
					alert("Error: " + errorThrown);
				}
			});
		}

		function add_message() {
			$('#form-message-text, #form-header, .form-subheader, #contact-kristi, #contact-kristi-footer, .contact-kristi-sub-heading').hide();
			
			var html = '<div style="margin-top:40px;text-align:center;">';
			html += '<span class="r-ga">' + CONTACT.response + '</span>';
			html += '<div style="margin-top:20px">' + CONTACT.home_link + '</div>';
			html += '</div>';
			window.document.getElementById('form_message').innerHTML = html;
		}
	});
})(jQuery);